import {
  makeMetricsPageLeave,
  makeMetricsPageLoad,
  startPulseMetric,
  pausePulseMetric,
} from '../../Metrics/webPageDispatchers';
import { isUserpilotCheckListChange } from '../../location/helpers';
import { selectLocationState } from '../../location/selectors.common';

export const onPageArrive = ({
  action: {
    location: { kind },
  },
  dispatch,
  metrics,
  resetMetrics,
  startPulse,
}) => {
  if (kind !== 'replace' && kind !== 'load') {
    dispatch(makeMetricsPageLoad({ metrics, resetMetrics }));
  }
  dispatch(startPulseMetric({ trigger: 'pageArrive', startPulse }));
};

export const onPageLeave = ({
  action,
  dispatch,
  metrics,
  saveMetric,
  getState,
  pausePulse,
}) => {
  const {
    location: { kind },
  } = action;

  // Issue: To help userpilot to target the block pages, we add ?cl=1
  // flag to block page urls - this triggers onLeave when ?cl=1 is
  // being added.
  //
  // This is to avoid sending metrics data when the ?cl=1 being added.
  if (isUserpilotCheckListChange(selectLocationState(getState()), action)) {
    return;
  }

  /* TODO does it make sense to have callbacks with { prev: true }
   * called on the initial load? */
  if (kind !== 'replace' && kind !== 'load') {
    dispatch(makeMetricsPageLeave({ metrics, saveMetric }));
  }
  dispatch(pausePulseMetric({ trigger: 'pageLeave', pausePulse }));
};
